const glassListTypes = ['3x25', '3x30', '3x40', 'wood'];

export default glassListTypes;
